// Offline pincode → state → DISCOM mapping for India.
// Uses the first 1–3 digits of the pincode (zones defined by India Post).

const ZONE_BY_2DIGIT = {
  11: { state: "Delhi", discom: "BRPL / BYPL / TPDDL (Delhi)" },
  12: { state: "Haryana", discom: "DHBVN / UHBVN" },
  13: { state: "Haryana", discom: "DHBVN / UHBVN" },
  14: { state: "Punjab", discom: "PSPCL" },
  15: { state: "Punjab", discom: "PSPCL" },
  16: { state: "Chandigarh", discom: "CED Chandigarh" },
  17: { state: "Himachal Pradesh", discom: "HPSEBL" },
  18: { state: "Jammu & Kashmir", discom: "JKPDD / KPDCL" },
  19: { state: "Jammu & Kashmir", discom: "JKPDD / KPDCL" },
  20: { state: "Uttar Pradesh", discom: "UPPCL" },
  21: { state: "Uttar Pradesh", discom: "UPPCL" },
  22: { state: "Uttar Pradesh", discom: "UPPCL" },
  23: { state: "Uttar Pradesh", discom: "UPPCL" },
  24: { state: "Uttar Pradesh", discom: "UPPCL" },
  25: { state: "Uttar Pradesh", discom: "UPPCL" },
  26: { state: "Uttar Pradesh", discom: "UPPCL" },
  27: { state: "Uttar Pradesh", discom: "UPPCL" },
  28: { state: "Uttar Pradesh", discom: "UPPCL" },
  30: { state: "Rajasthan", discom: "JVVNL / AVVNL / JdVVNL" },
  31: { state: "Rajasthan", discom: "JVVNL / AVVNL / JdVVNL" },
  32: { state: "Rajasthan", discom: "JVVNL / AVVNL / JdVVNL" },
  33: { state: "Rajasthan", discom: "JVVNL / AVVNL / JdVVNL" },
  34: { state: "Rajasthan", discom: "JVVNL / AVVNL / JdVVNL" },
  36: { state: "Gujarat", discom: "MGVCL / UGVCL / PGVCL / DGVCL" },
  37: { state: "Gujarat", discom: "MGVCL / UGVCL / PGVCL / DGVCL" },
  38: { state: "Gujarat", discom: "MGVCL / UGVCL / PGVCL / DGVCL" },
  39: { state: "Gujarat", discom: "MGVCL / UGVCL / PGVCL / DGVCL" },
  40: { state: "Maharashtra", discom: "MSEDCL / BEST / Adani / Tata Power" },
  41: { state: "Maharashtra", discom: "MSEDCL" },
  42: { state: "Maharashtra", discom: "MSEDCL" },
  43: { state: "Maharashtra", discom: "MSEDCL" },
  44: { state: "Maharashtra", discom: "MSEDCL" },
  45: { state: "Madhya Pradesh", discom: "MPMKVVCL / MPPKVVCL / MPPoKVVCL" },
  46: { state: "Madhya Pradesh", discom: "MPMKVVCL / MPPKVVCL / MPPoKVVCL" },
  47: { state: "Madhya Pradesh", discom: "MPMKVVCL / MPPKVVCL / MPPoKVVCL" },
  48: { state: "Madhya Pradesh", discom: "MPMKVVCL / MPPKVVCL / MPPoKVVCL" },
  49: { state: "Chhattisgarh", discom: "CSPDCL" },
  50: { state: "Telangana", discom: "TSSPDCL / TSNPDCL" },
  51: { state: "Andhra Pradesh", discom: "APSPDCL / APEPDCL / APCPDCL" },
  52: { state: "Andhra Pradesh", discom: "APSPDCL / APEPDCL / APCPDCL" },
  53: { state: "Andhra Pradesh", discom: "APSPDCL / APEPDCL / APCPDCL" },
  56: { state: "Karnataka", discom: "BESCOM" },
  57: { state: "Karnataka", discom: "MESCOM / CESC Mysore" },
  58: { state: "Karnataka", discom: "HESCOM / GESCOM" },
  59: { state: "Karnataka", discom: "HESCOM / GESCOM" },
  60: { state: "Tamil Nadu", discom: "TANGEDCO" },
  61: { state: "Tamil Nadu", discom: "TANGEDCO" },
  62: { state: "Tamil Nadu", discom: "TANGEDCO" },
  63: { state: "Tamil Nadu", discom: "TANGEDCO" },
  64: { state: "Tamil Nadu", discom: "TANGEDCO" },
  67: { state: "Kerala", discom: "KSEBL" },
  68: { state: "Kerala", discom: "KSEBL" },
  69: { state: "Kerala", discom: "KSEBL" },
  70: { state: "West Bengal", discom: "WBSEDCL / CESC Kolkata" },
  71: { state: "West Bengal", discom: "WBSEDCL" },
  72: { state: "West Bengal", discom: "WBSEDCL" },
  73: { state: "West Bengal", discom: "WBSEDCL" },
  74: { state: "West Bengal", discom: "WBSEDCL" },
  75: { state: "Odisha", discom: "TPCODL / TPNODL / TPSODL / TPWODL" },
  76: { state: "Odisha", discom: "TPCODL / TPNODL / TPSODL / TPWODL" },
  77: { state: "Odisha", discom: "TPCODL / TPNODL / TPSODL / TPWODL" },
  78: { state: "Assam", discom: "APDCL" },
  79: { state: "North-East", discom: "State Electricity Board" },
  80: { state: "Bihar", discom: "NBPDCL / SBPDCL" },
  81: { state: "Bihar", discom: "NBPDCL / SBPDCL" },
  82: { state: "Jharkhand", discom: "JBVNL" },
  83: { state: "Jharkhand", discom: "JBVNL" },
  84: { state: "Bihar", discom: "NBPDCL / SBPDCL" },
  85: { state: "Bihar", discom: "NBPDCL / SBPDCL" },
};

// Finer-grained overrides (first 3 digits) for major metros
const ZONE_BY_3DIGIT = {
  110: { state: "Delhi", discom: "BRPL / BYPL / TPDDL" },
  400: { state: "Maharashtra", discom: "Adani Electricity / BEST / Tata Power (Mumbai)" },
  560: { state: "Karnataka", discom: "BESCOM (Bengaluru)" },
  600: { state: "Tamil Nadu", discom: "TANGEDCO (Chennai)" },
  700: { state: "West Bengal", discom: "CESC Kolkata" },
  500: { state: "Telangana", discom: "TSSPDCL (Hyderabad)" },
  380: { state: "Gujarat", discom: "Torrent Power (Ahmedabad)" },
  395: { state: "Gujarat", discom: "Torrent Power (Surat)" },
};

export function lookupPincode(pincode) {
  if (!pincode) return null;
  const clean = String(pincode).replace(/\D/g, "");
  if (clean.length < 3) return null;
  const three = parseInt(clean.slice(0, 3), 10);
  if (!Number.isNaN(three) && ZONE_BY_3DIGIT[three]) return ZONE_BY_3DIGIT[three];
  const two = parseInt(clean.slice(0, 2), 10);
  if (!Number.isNaN(two) && ZONE_BY_2DIGIT[two]) return ZONE_BY_2DIGIT[two];
  return null;
}

export function isValidPincode(pincode) {
  if (!pincode) return false;
  return /^\d{6}$/.test(String(pincode).trim());
}
